/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

const integer2FullString = (dateNumber) => ('0' + dateNumber).slice(-2);

const bareDateTimeFormat = (inputDate, format, timeDate) => {
    const date = new Date(inputDate);
    const day = integer2FullString(date.getDate());
    const month = integer2FullString(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = integer2FullString(date.getHours());
    const minutes = integer2FullString(date.getMinutes());
    const seconds = integer2FullString(date.getSeconds());

    let bareDate = `${year}-${month}-${day} ${hours}:${minutes}`;
    if (format === 'dd/mm/YY') bareDate = `${day}/${month}/${year}`;
    else if (format === 'YY-mm-dd' || format === 'YYYY-mm-dd') bareDate = `${year}-${month}-${day}`;
    else if (format === 'filter') bareDate = `${year}-${month}-${day}${timeDate === 'start' ? 'T00:00:00' : 'T23:59:59'}`;
    //date return example: 01-12-2020 14:28:13 GMT
    else if (format === 'gmt') bareDate = `${day}-${month}-${year} ${hours}:${minutes}:${seconds} GMT`;
    else if (format === 'lt') bareDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    else if (format === 'hh:mm:ss') bareDate = `${hours}:${minutes}:${seconds}`;
    else if (format === 'dd/mm/YY hh:mm:ss') bareDate = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`; //date return example: 01-12-2020 14:28:13

    return bareDate;
};

const isDateReached = (date) => {
    const newDate = new Date(date.replace('T', ' ').replace(/-/g, '/'));
    const now = new Date();
    return newDate < now;
};

export { bareDateTimeFormat, isDateReached };
